interface CategoryinputOption {
    id: number;
    name: string;
    description?: string | null;
    children?: CategoryinputOption[];
}
  
interface CategoryOption {
    value: number;
    label: string;
    children?: CategoryOption[];
};


type Option = {
  value: string;
  label: string;
};

const enumChoice = {
    sex: [
        { value: "MALE", label: "Male"},
        { value: "FEMALE", label: "Female"}
    ],
    useRole: [
        { value: "ADMIN", label: "Admin"},
        { value: "CUSTOMER", label: "Customer"},
        { value: "STORE_MANAGER", label: "Store Manager"},
        { value: "PRODUCT_MANAGER", label: "Product Manager"},
        { value: "MARKETING_MANAGER", label: "Marketing Manager"},
        { value: "ORDER_PROCESSOR", label: "Order Processor"},
        { value: "CUSTOMER_SUPPORT_AGENT", label: "Customer Support Agent"},
        { value: "ACCOUNTANT", label: "Accountant"},
        { value: "VENDOR", label: "Vendor"},
        { value: "STORE_VIEWER", label: "Store Viewer"},

    ],
    stockStatus: [
      { value: "IN_STOCK", label: "In stock"},
      { value: "OUT_OF_STOCK", label: "Out of stock"}
    ],
    weightUnits: [
      { value: "KG", label: "Kilogram"},
      { value: "GRAM", label: "Gram"},
      { value: "OZ", label: "Ounce"},
      { value: "LB", label: "Pound"},
      { value: "TON", label: "Ton"}
    ],
    heightUnits: [
      { value: "CM", label: "Centimeter"},
      { value: "M", label: "Meter"},
      { value: "INCH", label: "Inch"},
      { value: "FT", label: "Feet"}
    ],
    publishableStatus: [
      {value: "DRAFT", label: "Draft"},
      { value: "PUBLISHED", label: "Published"},
      { value: "ARCHIVED", label: "Archived"}
    ],
    orderStatus: [
      { value: "PENDING", label: "Pending" },
      { value: "APPROVED", label: "Approved" },
      { value: "PACKED", label: "Packed" },
      { value: "SHIPPED", label: "Shipped" },
      { value: "DELIVERED", label: "Delivered" },
      { value: "CANCELLED", label: "Cancelled" },
      { value: "RETURNED", label: "Returned" },
      { value: "PENDING_RETURN", label: "Pending Return" },
    ],    
    authorizeStatus: [
      {value: "NONE", label: "No funds are authorized"},
      {value: "PARTIAL", label: "Partially authorized; funds don't fully cover the order's total"},
      {value: "FULL", label: "Fully authorized; funds cover the order's total"}
    ],
    chargeStatus: [
      { value: "DUE", label: "Due" },
      { value: "PARTIAL", label: "Partially charged" },
      { value: "FULL", label: "Fully charged" },
      { value: "OVERCHARGED", label: "Overcharged" }
    ],
    paymentStatus: [
      { value: "AUTHORIZED", label: "Authorized" },
      { value: "CAPTURED", label: "Captured" },
      { value: "FAILED", label: "Failed" },
      { value: "REFUNDED", label: "Refunded" },
      { value: "CANCELED", label: "Canceled" },
      { value: "PARTIALLY_REFUNDED", label: "Partially Refunded" },
      { value: "UNDER_REVIEW", label: "Under Review" },
      { value: "PENDING", label: "Pending" }
    ],
    paymentMethods: [
      { value: "CREDIT_CARD", label: "Credit Card" },
      { value: "PAYPAL", label: "PayPal" },
      { value: "BANK_TRANSFER", label: "Bank Transfer" },
      { value: "CASH_ON_DELIVERY", label: "Cash on Delivery" },
      { value: "GIFT_CARD", label: "Gift Card" },
      { value: "DIRECT_DEBIT", label: "Direct Debit" },
      { value: "CASH_IN_STORE", label: "Cash in Store" },
      { value: "MFS", label: "Mobile Financial Services" },
      { value: "CARRIER_BILLING", label: "Carrier Billing" },
      { value: "CRYPTOCURRENCY", label: "Cryptocurrency" },
      { value: "BUY_NOW_PAY_LATER", label: "Buy Now, Pay Later" },
      { value: "E_WALLET", label: "E-Wallet" },
      { value: "BANK_TRANSFER_INSTANT", label: "Instant Bank Transfer" },
      { value: "POSTAL_MONEY_ORDER", label: "Postal Money Order" },
      { value: "CHEQUE", label: "Cheque" },
      { value: "OTHER", label: "Other" },
      { value: "AWAITING_SELECTION", label: "Awaiting Selection" }
    ],
    activeStatus: [
      { value: "ACTIVE", label: "Active" },
      { value: "INACTIVE", label: "Inactive" }
    ],
    promoCodeType: [
      { value: "PERCENTAGE", label: "Percentage" },
      { value: "FIXED", label: "Fixed" }
    ],
    currency: [
      { value: "USD", label: "United States Dollar" },
      { value: "EUR", label: "Euro" },
      { value: "JPY", label: "Japanese Yen" },
      { value: "GBP", label: "British Pound" },
      { value: "AUD", label: "Australian Dollar" },
      { value: "CAD", label: "Canadian Dollar" },
      { value: "CHF", label: "Swiss Franc" },
      { value: "CNY", label: "Chinese Yuan" },
      { value: "SEK", label: "Swedish Krona" },
      { value: "NZD", label: "New Zealand Dollar" },
      { value: "MXN", label: "Mexican Peso" },
      { value: "SGD", label: "Singapore Dollar" },
      { value: "HKD", label: "Hong Kong Dollar" },
      { value: "NOK", label: "Norwegian Krone" },
      { value: "KRW", label: "South Korean Won" },
      { value: "TRY", label: "Turkish Lira" },
      { value: "INR", label: "Indian Rupee" },
      { value: "RUB", label: "Russian Ruble" },
      { value: "BRL", label: "Brazilian Real" },
      { value: "ZAR", label: "South African Rand" },
      { value: "MYR", label: "Malaysian Ringgit" },
      { value: "THB", label: "Thai Baht" },
      { value: "IDR", label: "Indonesian Rupiah" },
      { value: "PHP", label: "Philippine Peso" },
      { value: "VND", label: "Vietnamese Dong" },
      { value: "PLN", label: "Polish Zloty" },
      { value: "CZK", label: "Czech Koruna" },
      { value: "HUF", label: "Hungarian Forint" },
      { value: "ILS", label: "Israeli Shekel" },
      { value: "SAR", label: "Saudi Riyal" },
      { value: "AED", label: "United Arab Emirates Dirham" },
      { value: "CLP", label: "Chilean Peso" },
      { value: "COP", label: "Colombian Peso" },
      { value: "ARS", label: "Argentine Peso" },
      { value: "PEN", label: "Peruvian Sol" },
      { value: "PKR", label: "Pakistani Rupee" },
      { value: "EGP", label: "Egyptian Pound" },
      { value: "NGN", label: "Nigerian Naira" },
      { value: "BDT", label: "Bangladeshi Taka" },
      { value: "LKR", label: "Sri Lankan Rupee" },
      { value: "KWD", label: "Kuwaiti Dinar" },
      { value: "BHD", label: "Bahraini Dinar" },
      { value: "QAR", label: "Qatari Riyal" },
      { value: "OMR", label: "Omani Rial" }
    ],
    paymentTerms:  [
      { value: "DUE_ON_RECEIPT", label: "Due on receipt" },
      { value: "DUE_ON_FULFILLMENT", label: "Due on fulfillment" },
      { value: "DUE_ON_INSTALLMENT", label: "Due on installment" },
      { value: "FIXED_DATE", label: "Due on fixed date" },
    
      // Frontend-specific options
      { value: "7", label: "Within 7 days" },
      { value: "15", label: "Within 15 days" },
      { value: "30", label: "Within 30 days" },
      { value: "45", label: "Within 45 days" },
      { value: "60", label: "Within 60 days" },
      { value: "90", label: "Within 90 days" }
    ],
    addressTypes: [
      {value: "DSA", label: "Default Shipping Address"},
      {value: "DBA", label: "Default Billing Address"},
      {value: "SA", label: "Shipping Address"},
      {value: "BA", label: "Billing Address"},
      {value: "DSA_DBA", label: "Default Shipping and Billing Address"}
    ],
    returnReasons: [
      { value: "DAMAGED", label: "Damaged" },
      { value: "DEFECTIVE", label: "Defective" },
      { value: "WRONG_PRODUCT", label: "Wrong Product" },
      { value: "WRONG_SIZE", label: "Wrong Size" },
      { value: "WRONG_COLOR", label: "Wrong Color" },
      { value: "WRONG_VARIANT", label: "Wrong Variant" },
      { value: "NOT_AS_EXPECTED", label: "Not as Expected" },
      { value: "NO_REASON", label: "No Reason" },
      { value: "OTHER", label: "Other" }
    ],
    returnStatuses: [
      { value: "REQUESTED", label: "Requested" },
      { value: "APPROVED", label: "Approved" },
      { value: "REJECTED", label: "Rejected" },
      { value: "REVIEWED", label: "Reviewed" },
      { value: "COMPLETED", label: "Completed" },
      { value: "CANCELLED", label: "Cancelled" }
    ],
    returnReceivingStatuses: [
      {'value': 'RECEIVED', 'label': 'Received'},
      {'value': 'NOT_RECEIVED', 'label': 'Not Received'},
      {'value': 'RECEIVED_WITH_ISSUES', 'label': 'Received with Issues'}
    ],
    movementType: [
      {'value': 'PURCHASE', 'label': 'Purchase'},
      {'value': 'TRANSFER_IN', 'label': 'Transfer In'},
      {'value': 'TRANSFER_OUT', 'label': 'Transfer Out'},
      {'value': 'SALE', 'label': 'Sale'},
      {'value': 'RETURN', 'label': 'Return'},
    ],
    purchaseStatus: [
      {'value': 'DRAFT', 'label': 'Draft'},
      {'value': 'PENDING', 'label': 'Pending'},
      {'value': 'RECEIVED', 'label': 'Received'},
      {'value': 'CANCELLED', 'label': 'Cancelled'},
    ],
    orderStockReservationStatus: [
      { "value": "RESERVED", "label": "Reserved" },
      { "value": "RELEASED", "label": "Released" },
      { "value": "INSUFFICIENT_STOCK", "label": "Insufficient stock" },
      { "value": "NOT_REQUIRED", "label": "Not Required" },
      { "value": "FAILED", "label": "Failed" },
      { "value": "DISPATCHED", "label": "Dispatched" }
  ]
  
    
}

// Extend the Array prototype

declare global {
  interface Array<T> {
    toKV(): { [key: string]: { label: any, value: any } }; // Use `any` for the label type
  }
}

Array.prototype.toKV = function (): { [key: string]: { label: any, value: any } } {
  return this.reduce((acc, { value, label }: { value: any; label: any }) => {
    acc[value] = { label, value };
    return acc;
  }, {} as { [key: string]: { label: any } });
};

const getEnumLabel = (enumArray: { value: string; label: string }[], value: string): string | undefined => {
  const foundItem = enumArray.find(item => item.value === value);
  return foundItem ? foundItem.label : undefined;
};


function makeCategoryEnumFriendly(data: CategoryinputOption[]): CategoryOption[] {
    return data.map(item => {
      let transformedItem: CategoryOption = {
        value: item.id,
        label: item.name,
      };
      if (item.children && item.children.length > 0) {
        transformedItem.children = makeCategoryEnumFriendly(item.children);
      }
      return transformedItem;
    });
};

function makeEnumFriendly(data: any[]): Option[] {
  return data.map(item => ({
      value: item.id,
      label: item.name
  }));
};

function makeTagEnumFriendly(data: any[]): Option[] {
  return data.map(item => ({
      value: item.name,
      label: item.name
  }));
};

function makeColorEnumFriendly(data: any[]): Option[] {
  return data.map(item => ({
      value: item.code,
      label: item.name
  }));
};

const getColorEnumItem = (arr: any[], val: string): { value: string, label: string } | undefined => {
  const foundItem = arr?.find(item => item.code === val);

  if (foundItem) {
    return {
      value: foundItem.code,
      label: foundItem.name
    };
  }

  return undefined;
};



const getEnumItem = <T extends { id?: string | number, value?: string | number, name?: string, label?: string }>(
  arr: T[],
  val: string | number
): { value: string, label: string } | undefined => {

  if (val === undefined) {
    // If val is undefined, return undefined
    return undefined;
  }
  const foundItem = arr?.find(item => item.id === val || item.value === val);

  if (foundItem) {
    const obj = {
      value: String(foundItem.id ?? foundItem.value), // Use id if present, otherwise use value
      label: foundItem.name ?? foundItem.label ?? "" // Use name if present, otherwise use label, or default to empty string
    };
    return obj;
  }

  return undefined;
};




const transformSingleEnum = (data: any) => {
  return {
    value: data.id,
    label: data.name
  };
}


const getEnumList = <T extends { value: string | number }>(baseArr: T[], arr: (string | number)[]): T[] => {
  const data = baseArr.filter(el => {
      return arr?.some(f => f === el.value);
  });
  return data;
};



export { getEnumLabel, makeCategoryEnumFriendly, makeEnumFriendly, getEnumItem, getEnumList, transformSingleEnum, makeColorEnumFriendly, getColorEnumItem, makeTagEnumFriendly };

export default enumChoice;